export enum AssistantType {
  E_MOBILITY = 'emobilityInterest',
  SOLAR = 'solarRoofShape',
  HEATING = 'heatingType',
  COMBI = 'combiInterest',
  // Entry point of the print/QR campaign. Deliberately not listed in
  // ~/assistants: it has no sidebar tile, it only routes into the heating or
  // the combi assistant.
  HEAT_OR_COMBI = 'heatOrCombi',
}
